module.exports = __webpack_public_path__ + "img/esfera.dbdbb031.png";